angular.module('uofa.agentsportal').controller('CollapseCtrl', function ($scope) {
  $scope.isCollapsed = true;
});
